import React, { useState, useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Popup from '../Popup';
import useApi from '../../hooks/useApi';
import { getImageUrl } from '../../utils';
import StartHubArrow from '../../../public/assets/images/theme-2/icons/arrow.svg';
import { HubList, HubWrapper, HubImage, HubName, ColumnWrapper, Wrapper, InfoPanel, StartHubImage } from './styles';

const ReorderHubsPopup = ({ loopId, fileService, userToken, popupIsOpen, onClose, flash, onRender }) => {
  const { getData, postData } = useApi(userToken);
  const [hubs, setHubs] = useState([]);

  useEffect(() => {
    onRender && onRender();
  });

  useEffect(() => {
    const getHubs = async () => {
      const response = await getData(`/api/v3/circles/${loopId}/hubs`);
      if (response.success) {
        setHubs(response.body);
      }
    };
    if (popupIsOpen) {
      getHubs();
    }
  }, [popupIsOpen]);

  const reorder = (startIndex, endIndex) => {
    const result = Array.from(hubs);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }
    const reorderedHubs = reorder(result.source.index, result.destination.index);
    setHubs(reorderedHubs);
  };

  const onClick = async (ev) => {
    const res = await postData(
      `/api/v3/circles/${loopId}/huborder`,
      hubs.map((hub) => hub.uuid),
    );
    if (res.success) {
      onClose(ev, hubs[0].uuid);
      flash(i18n.__('flash_state_changed'), { type: 'status' });
    } else {
      console.error(res);
      if (res.message === 'auth_failed') {
        flash(i18n.__('app_error_unauthorized'));
      } else {
        flash(i18n.__('app_error_alert'));
      }
    }
  };

  const contentPanel = (
    <ColumnWrapper>
      <InfoPanel>{i18n.__('reorder_hubs_info')}</InfoPanel>
      <Wrapper>
        <StartHubImage icon={StartHubArrow} role="img" title={i18n.__('app_start_hub')} />
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <HubList {...provided.droppableProps} ref={provided.innerRef}>
                {hubs.map((hub, index) => (
                  <Draggable key={hub.id} draggableId={hub.uuid} index={index}>
                    {(provided) => (
                      <HubWrapper ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <HubImage icon={getImageUrl(fileService, hub.image, '220x220')} />
                        <HubName>{hub.name}</HubName>
                      </HubWrapper>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </HubList>
            )}
          </Droppable>
        </DragDropContext>
      </Wrapper>
    </ColumnWrapper>
  );

  const onTransitionEnd = () => {
    if (popupIsOpen) {
      const items = document.querySelectorAll('li[role="button"]');
      items.forEach((item) => item.removeAttribute('role'));
    }
  };

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      id="hubOrderPopup"
      heading={i18n.__('reorder_hubs_header')}
      contentPanel={contentPanel}
      buttonLabel={i18n.__('app_save')}
      onClose={onClose}
      onClick={onClick}
      onTransitionEnd={onTransitionEnd}
      width={500}
    />
  );
};

export default ReorderHubsPopup;
